export default "/_next/static/chunks/fonts/Montserrat-Light-latin-e522f180b859b145063b736389ca35a7.woff2";